import React from 'react';
import RoomIcon from '@material-ui/icons/Room';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Link from '@material-ui/core/Link';
import ListItemText from '@material-ui/core/ListItemText';
import Introduction from '../components/Introduction';
import {
  V1UsersiteBusinessesGetOneTypePayload,
  V1UsersiteBusinessAddressesGetOneTypePayload,
} from '~/models/schema';
import Hidden from '@material-ui/core/Hidden';

const Paragraph = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      marginTop: 20,
    },
  },
}))(Typography);

const Icon = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    marginRight: 5,
  },
}))(RoomIcon);

interface AddressProps extends V1UsersiteBusinessAddressesGetOneTypePayload {}

const Address = ({ region, city }: AddressProps) => (
  <Paragraph display="inline" variant="body2" color="textPrimary">
    <Icon fontSize="small" />
    <span className="text-break-all line-truncate-2">
      {[region?.name, city].filter(Boolean).join(' ')}
    </span>
  </Paragraph>
);

const ItemText = withStyles((theme) => ({
  root: {
    margin: theme.spacing(0, 2.5),
  },
}))(ListItemText);

const NameLink = withStyles((theme) => ({
  root: {
    color: '#333333',
    marginTop: 0,
    [theme.breakpoints.up('md')]: {
      marginTop: 10,
    },
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))(Link);

interface Props extends V1UsersiteBusinessesGetOneTypePayload {}

const BusinessInfo = ({ name, url, introduction, address }: Props) => (
  <ItemText
    disableTypography
    primary={
      <NameLink
        href={url}
        className="line-truncate-2 text-break-all"
        underline="always"
      >
        {name}
      </NameLink>
    }
    secondary={
      <>
        {address && <Address {...address} />}
        {!!introduction && (
          <Hidden xsDown>
            <Introduction value={introduction} className="line-truncate-2" />
          </Hidden>
        )}
      </>
    }
  />
);

export default BusinessInfo;
